module.exports = __webpack_public_path__ + "static/media/logo2.02cae318.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo2.png
// module id = 35
// module chunks = 0